import USER_ROLES from "../../../constants/userRoles.constants";

class MyEvaluationListController {
    constructor($filter, $state, evaluationService, listService, userService) {
        this.$filter = $filter;
        this.$state = $state;
        this.listService = listService;
        this.evaluationService = evaluationService;
        this.userService = userService;
        this.isAdmin = this.userService.isInRole(USER_ROLES.ROLE_ADMIN);

        this.evaluations = [];
        this.editedByMe = false;
        this.query = {
            order: '-id',
        };
        this.visibleRowsLimit = 20;
    }

    $onInit() {
        this.getProducts();
    }

    getProducts() {
        this.listService.getProductsByUser().then((res) => this.products = res)
            .catch(e => console.log('ERROR', e));
    }

    getEvaluations() {
        this.evaluationService.getEvaluationsByLoggedUser().then((res) => this.evaluations = res)
            .catch(e => console.log('ERROR', e));
    }

    disableLimit(numberOfRecords) {
        this.visibleRowsLimit = numberOfRecords;
    }

    displayDate(input) {
        if (isNaN(input)) {
            return input;
        }

        return this.$filter('date')(`${input}000`, 'dd.MM.yyyy');
    }

    goToEvaluation(evaluation) {
        this.$state.go('mySubEvaluationList', {productId: evaluation.id});
    }

    findProducts(searchText) {
        searchText = searchText ? searchText.trim() : '';
        if (searchText) {
            this.listService.searchProducts(searchText, self.editedByMe).then((res) => {
                this.products = res;
            }).catch(e => console.log('ERROR', e));
        } else {
            this._getProducts();
        }
    }

    printExpireComment(date) {
        if(date) {
            date = (new Date(date)).setMinutes(0,0,0);
            let now = (new Date()).setHours(0,0,0);
            const days = Math.floor((date - now) / (1000 * 60 * 60 * 24));
            if(days > 0) {
                return 'expires in ' + days + ' days';
            } else if(days < 0) {
                return 'expired ' + (-days) + ' days ago';
            } else {
                const hours = Math.floor((date - now) / (1000 * 60 * 24));

                if(hours >= 0) {
                    return 'expires in ' + hours + ' hours';
                } else if(hours < 0) {
                    return 'expired ' + (-hours) + ' hours ago';
                }
            }
        }
    }
}

MyEvaluationListController.$inject = [
    '$filter',
    '$state',
    'EvaluationService',
    'ListService',
    'UserService'
];

export default MyEvaluationListController;



// WEBPACK FOOTER //
// ./src/app/pages/lists/myEvaluationList/myEvaluationListController.js